/**
 * Created by r4zi4l on 01.09.2022
 */

const ClansCupWindow = CleverappsWindow.extend({
    listBundles: function () {
        return ["clan"];
    },

    onWindowLoaded: function () {
        this._super({
            name: "ClansCupWindow",
            title: Messages.get("Cups.clan.title"),
            content: this.createContent(),
            help: function () {
                cleverapps.focusManager.display({
                    focus: "ClanCupHelp",
                    stack: true,
                    action: function (f) {
                        new GuideWindow({
                            name: "ClanCupGuideWindow",
                            bundle: bundles.clancupguidewindow
                        });
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.ClansCupWindow;

        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(styles.width, styles.height);

        const table = this.table = this.createTable();
        table.setAlignment(styles.table);
        content.addChild(table);

        const tabs = this.createTabs();
        tabs.setAlignment(styles.tabs);
        tabs.setLocalZOrder(2);
        table.addChild(tabs);

        const timer = this.timer = this.createTimerBlock();
        timer.setAlignment(styles.timer);
        content.addChild(timer);

        const finishText = this.finishText = cleverapps.UI.generateOnlyText(Messages.get("Finished"), cleverapps.styles.FONTS.DARK_TEXT);
        finishText.setAlignment(styles.finishText);
        content.addChild(finishText);

        this.updateState();

        cleverapps.clanCup.reload();
        cleverapps.clanCupInner.reload(true);

        cleverapps.clanCup.on("update", this.createListener(this.updateState.bind(this)), this);

        return content;
    },

    updateState: function () {
        if (cleverapps.clanCup.isRunning()) {
            this.timer.setVisible(true);
            this.timer.countdown.countDown.resetTimeLeft(cleverapps.clanCup.getTimeLeft());
            this.finishText.setVisible(false);
        } else if (!cleverapps.clanCup.isFinished()) {
            this.timer.setVisible(false);
            this.finishText.setVisible(true);
            this.finishText.setString(Messages.get("ClansCupWindow.summingUp"));
        } else {
            this.timer.setVisible(false);
            this.finishText.setVisible(true);
            this.finishText.setString(Messages.get("Finished"));
        }
    },

    createTable: function () {
        const styles = cleverapps.styles.ClansCupWindow.table;

        const background = cleverapps.UI.createScale9Sprite(bundles.clan.frames.table_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize2(styles.width, styles.height);

        const foreground = cleverapps.UI.createScale9Sprite(bundles.clan.frames.table_fg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        foreground.setContentSize2(background.width, background.height);
        foreground.setAlignment(background.width / 2, background.height / 2);
        background.addChild(foreground, 1);

        return background;
    },

    createTabs: function () {
        const styles = cleverapps.styles.ClansCupWindow;

        const info = {
            0: {
                text: Messages.get("ClansCupWindow.top"),
                generator: this.createTab.bind(this, cleverapps.clanCup)
            },
            1: {
                text: Messages.get("ClansCupWindow.myclan"),
                generator: this.createTab.bind(this, cleverapps.clanCupInner)
            }
        };

        const tabs = new Tabs(info, styles.tabs);
        tabs.activateTab(0);
        return tabs;
    },

    createTab: function (cup) {
        const styles = cleverapps.styles.ClansCupWindow.table;

        const tableRect = cc.rectSubPadding(cc.rect(0, 0, styles.width, styles.height), cc.padding(styles.padding));

        const tableView = new CupTableView(cup, (() => {
            const view = new cleverapps.UI.ScrollView(new cc.Node(), {
                scrollBarEnabled: !cup.table.scrollDisabled,
                mouseScroll: !cup.table.scrollDisabled,
                dock: true
            });

            new TableHandler(cup.table, view, {
                id: cup.type,
                height: tableRect.height,
                rowConstructor: ClansRow,
                rowOptions: {
                    prizes: true,
                    badges: true
                },
                innerPadding: styles.innerPadding
            });
            return view;
        }), {
            scaleDuration: 0.3,
            scaleEasing: cc.easeInOut(1)
        });
        tableView.setAlignment(tableRect.x + tableRect.width / 2, tableRect.y + tableRect.height / 2);
        this.table.addChild(tableView);

        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.CUP_DAU + cup.type);

        return tableView;
    },

    createTimerBlock: function () {
        const styles = cleverapps.styles.ClansCupWindow.timer;

        const leftTime = cleverapps.clanCup.getTimeLeft();
        const countdown = new cleverapps.CountDownView(new cleverapps.CountDown(leftTime), {
            font: cleverapps.styles.FONTS.TIMER_TEXT,
            background: {
                frame: bundles.timer.frames.timer_bg_png,
                width: styles.width,
                height: styles.height
            },
            icon: {
                frame: bundles.timer.frames.timer_png
            }
        });

        const text = cleverapps.UI.generateOnlyText(Messages.get("TimeLeft"), cleverapps.styles.FONTS.DARK_TEXT);

        const timer = new cleverapps.Layout([text, countdown], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
        timer.countdown = countdown;

        return timer;
    },

    onClose: function () {
        cleverapps.clanCup.afterWindowShown();
    }
});

cleverapps.styles.ClansCupWindow = {
    width: 1280,
    height: 940,

    table: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: -60 },
        width: 1320,
        height: 800,
        innerPadding: 30,

        padding: {
            x: 0,
            y: 40
        }
    },

    timer: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 0 },
        width: 270,
        height: 60,
        margin: 10
    },

    finishText: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 0 }
    },

    tabs: {
        x: { align: "left", dx: 70 },
        y: { align: "top", dy: 70 },
        direction: cleverapps.UI.HORIZONTAL,
        type: Tabs.Types.tabs_custom,
        width: 340,
        height: 77,
        margin: 20
    }
};